/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/ambulance'
export default icon
